// Rootwalk theme scripts. Every init function takes a root element so it can be
// re-run for a single section when the theme editor reloads it.

function bump(el) {
  el.classList.remove("bump");
  void el.offsetWidth; // herstart de animatie
  el.classList.add("bump");
}

function formatMoney(cents, format) {
  const amount = (cents / 100).toFixed(2);
  const [whole, decimals] = amount.split(".");
  const group = (sep) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  return (format || "€{{amount_with_comma_separator}}").replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
    if (key === "amount_no_decimals") return group(",");
    if (key === "amount_with_comma_separator") return `${group(".")},${decimals}`;
    if (key === "amount_no_decimals_with_comma_separator") return group(".");
    if (key === "amount_with_apostrophe_separator") return `${group("'")}.${decimals}`;
    return `${group(",")}.${decimals}`;
  });
}

// Header: menupaneel op mobiel (schuift over het scherm, submenu's schuiven erin)
// en dropdowns op desktop. Alle items komen uit het hoofdmenu van Shopify.
function initMenu(root) {
  const header = root.querySelector("[data-header]");
  if (!header) return;
  const drawer = header.querySelector("[data-drawer]");
  const toggle = header.querySelector("[data-drawer-open]");
  const panels = [...drawer.querySelectorAll("[data-panel]")];
  let savedScroll = 0;

  const isOpen = () => drawer.classList.contains("is-open");

  const showPanel = (name) => {
    panels.forEach((panel) => {
      const active = panel.dataset.panel === name;
      panel.classList.toggle("is-active", active);
      panel.toggleAttribute("inert", !active);
      panel.setAttribute("aria-hidden", String(!active));
    });
    drawer.classList.toggle("is-sub", name !== "main");
    drawer.querySelectorAll("[data-panel-open]").forEach((button) =>
      button.setAttribute("aria-expanded", String(button.dataset.panelOpen === name))
    );
    const panel = panels.find((p) => p.dataset.panel === name);
    if (name !== "main") panel?.querySelector("[data-panel-back]")?.focus({ preventScroll: true });
  };

  // De pagina eronder staat vast zolang het menu open is (ook op iOS).
  const lockScroll = () => {
    savedScroll = window.scrollY;
    Object.assign(document.body.style, { position: "fixed", top: `-${savedScroll}px`, left: "0", right: "0" });
    document.documentElement.classList.add("no-scroll");
  };
  const unlockScroll = () => {
    Object.assign(document.body.style, { position: "", top: "", left: "", right: "" });
    document.documentElement.classList.remove("no-scroll");
    window.scrollTo({ top: savedScroll, behavior: "instant" });
  };

  const open = () => {
    if (isOpen()) return;
    showPanel("main");
    drawer.classList.add("is-open");
    drawer.removeAttribute("inert");
    drawer.setAttribute("aria-hidden", "false");
    toggle.setAttribute("aria-expanded", "true");
    lockScroll();
    history.pushState({ rootwalkMenu: true }, "");
    drawer.querySelector("[data-drawer-close]").focus({ preventScroll: true });
  };

  // fromHistory: gesloten via de terugknop van de browser (dan niet nog eens terug).
  const close = (fromHistory = false) => {
    if (!isOpen()) return;
    drawer.classList.remove("is-open", "is-sub");
    drawer.setAttribute("inert", "");
    drawer.setAttribute("aria-hidden", "true");
    toggle.setAttribute("aria-expanded", "false");
    unlockScroll();
    toggle.focus({ preventScroll: true });
    if (!fromHistory && history.state?.rootwalkMenu) history.back();
  };

  toggle.addEventListener("click", open);
  drawer.querySelector("[data-drawer-close]").addEventListener("click", () => close());
  drawer.addEventListener("keydown", (event) => event.key === "Escape" && close());
  drawer.querySelectorAll("[data-panel-open]").forEach((button) =>
    button.addEventListener("click", () => showPanel(button.dataset.panelOpen))
  );
  drawer.querySelectorAll("[data-panel-back]").forEach((button) => button.addEventListener("click", () => showPanel("main")));
  // Bij een link in het menu: eerst sluiten zonder history.back(), anders gaat de navigatie verloren.
  drawer.querySelectorAll("a[href]").forEach((link) => link.addEventListener("click", () => {
    if (history.state?.rootwalkMenu) history.replaceState(null, "");
    close(true);
  }));
  if (!drawer.dataset.historyBound) {
    drawer.dataset.historyBound = "true";
    window.addEventListener("popstate", () => close(true));
  }
  window.matchMedia("(min-width: 961px)").addEventListener("change", (event) => event.matches && close());

  // Desktop: dropdown bij hover (muis) en bij klik/toetsenbord.
  const dropdowns = [...header.querySelectorAll("[data-nav-dropdown]")];
  const canHover = window.matchMedia("(hover: hover)");
  dropdowns.forEach((dropdown) => {
    let timer;
    dropdown.addEventListener("mouseenter", () => {
      if (!canHover.matches) return;
      clearTimeout(timer);
      dropdown.open = true;
    });
    dropdown.addEventListener("mouseleave", () => {
      if (!canHover.matches) return;
      timer = setTimeout(() => (dropdown.open = false), 150);
    });
    dropdown.addEventListener("toggle", () => {
      if (dropdown.open) dropdowns.forEach((other) => other !== dropdown && (other.open = false));
    });
    dropdown.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        dropdown.open = false;
        dropdown.querySelector("summary").focus();
      }
    });
  });
  document.addEventListener("click", (event) => {
    dropdowns.forEach((dropdown) => !dropdown.contains(event.target) && (dropdown.open = false));
  });

  header.querySelectorAll("[data-autosubmit]").forEach((select) => select.addEventListener("change", () => select.form.submit()));
}

// Aankondigingsbalk: wisselt om de paar seconden van boodschap.
function initAnnouncement(root) {
  root.querySelectorAll("[data-announcement]").forEach((bar) => {
    const messages = [...bar.querySelectorAll(".announcement-message")];
    if (messages.length < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let current = 0;
    setInterval(() => {
      messages[current].classList.remove("is-active");
      current = (current + 1) % messages.length;
      messages[current].classList.add("is-active");
    }, Number(bar.dataset.interval || 5) * 1000);
  });
}

// Bolletjes onder een horizontale scrollrij (USP-balk op mobiel).
function initScrollDots(root) {
  root.querySelectorAll("[data-trust-slider]").forEach((list) => {
    const dots = [...(list.parentElement.querySelector(".trust-dots")?.children || [])];
    if (!dots.length) return;
    list.addEventListener(
      "scroll",
      () => {
        const index = Math.round(list.scrollLeft / list.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
      },
      { passive: true }
    );
  });
}

// Collectiefilters: direct toepassen bij een wijziging, zonder lege parameters.
// Op mobiel opent de knop "Filters" een paneel met dezelfde keuzes.
function initFilters(root) {
  root.querySelectorAll("[data-filter-form]").forEach((form) => {
    const apply = () => {
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => value && params.append(key, value));
      window.location.href = `${form.action}?${params}`;
    };
    form.addEventListener("change", apply);
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      apply();
    });

    const pills = [...form.querySelectorAll("[data-filter-pill]")];
    pills.forEach((pill) =>
      pill.addEventListener("toggle", () => {
        if (pill.open && window.matchMedia("(min-width: 761px)").matches) pills.forEach((other) => other !== pill && (other.open = false));
      })
    );
    document.addEventListener("click", (event) => {
      if (window.matchMedia("(min-width: 761px)").matches) pills.forEach((pill) => !pill.contains(event.target) && (pill.open = false));
    });

    const toggle = form.querySelector("[data-filter-toggle]");
    const panel = form.querySelector("[data-filter-panel]");
    const setOpen = (open) => {
      panel.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", String(open));
      document.documentElement.classList.toggle("no-scroll", open);
    };
    toggle?.addEventListener("click", () => setOpen(!panel.classList.contains("is-open")));
    form.querySelector("[data-filter-close]")?.addEventListener("click", () => setOpen(false));
  });
}

// Schoenvinder: bundelt de gekozen antwoorden tot één zoekopdracht.
function initShoeFinder(root) {
  root.querySelectorAll("[data-shoe-finder]").forEach((form) => {
    form.addEventListener("submit", () => {
      const terms = [...form.querySelectorAll("select[data-term]")].map((s) => s.value).filter(Boolean);
      form.querySelector('input[name="q"]').value = terms.join(" ");
    });
  });
}

// Aftellen naar een vaste einddatum; verdwijnt als de datum voorbij is.
function initCountdowns(root) {
  root.querySelectorAll("[data-countdown]").forEach((box) => {
    const end = new Date(box.dataset.countdown);
    if (!box.dataset.countdown || isNaN(end)) return;
    const parts = Object.fromEntries([...box.querySelectorAll("[data-cd]")].map((el) => [el.dataset.cd, el]));
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        box.hidden = true;
        clearInterval(timer);
        return;
      }
      const s = Math.floor(left / 1000);
      const values = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      Object.entries(values).forEach(([key, value]) => parts[key] && (parts[key].textContent = String(value).padStart(2, "0")));
      box.hidden = false;
    };
    const timer = setInterval(tick, 1000);
    tick();
  });
}

// Verzenddatum: vandaag + het ingestelde aantal werkdagen (za/zo overgeslagen).
function initShipDates(root) {
  root.querySelectorAll("[data-ship-date]").forEach((el) => {
    let days = Number(el.dataset.shipDays);
    if (!days) return;
    const date = new Date();
    while (days > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) days--;
    }
    el.textContent = date.toLocaleDateString(document.documentElement.lang || undefined, { weekday: "short", day: "numeric", month: "short" });
  });
}

function initProduct(root) {
  root.querySelectorAll("[data-product]").forEach((section) => {
    const form = section.querySelector("[data-product-form]");
    if (!form) return;
    const strings = section.dataset;
    const variants = JSON.parse(section.querySelector("[data-variants]").textContent);
    const idInput = form.querySelector('input[name="id"]');
    const button = form.querySelector("[data-add-button]");
    const buttonLabel = button?.querySelector("[data-add-label]") || button;
    const msg = form.querySelector("[data-form-msg]");
    const fieldsets = [...form.querySelectorAll("[data-option]")];
    const qtyInputs = [...form.querySelectorAll("[data-qty-input]")];
    const lowStock = form.querySelector("[data-low-stock]");
    let currentVariant = variants.find((v) => String(v.id) === idInput.value);
    const colorIndex = fieldsets.findIndex((fs) => /^(colou?r|kleur)$/i.test(fs.dataset.optionName || ""));

    // Verhaalfoto's verderop op de pagina tonen dezelfde kleur als de gekozen kleur.
    const showColorMedia = (color) => {
      document.querySelectorAll("[data-color-media]").forEach((box) => {
        const images = [...box.querySelectorAll("[data-color]")];
        if (!images.some((img) => img.dataset.color === color)) return;
        images.forEach((img) => img.classList.toggle("is-hidden", img.dataset.color !== color));
      });
    };

    // Galerij: miniaturen, bolletjes en (op mobiel) een swipebare rij.
    const track = section.querySelector("[data-gallery-track]");
    const slides = track ? [...track.children] : [];
    const thumbs = [...section.querySelectorAll("[data-thumb]")];
    const dots = [...section.querySelectorAll(".gallery-dots span")];
    const mobile = window.matchMedia("(max-width: 760px)");
    const showSlide = (index, scroll = true) => {
      if (index == null || !slides[index]) return;
      slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
      thumbs.forEach((thumb, i) => thumb.setAttribute("aria-pressed", String(i === index)));
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
      if (scroll && mobile.matches) track.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
    };
    thumbs.forEach((thumb) => thumb.addEventListener("click", () => showSlide(Number(thumb.dataset.thumb))));
    track?.addEventListener(
      "scroll",
      () => mobile.matches && showSlide(Math.round(track.scrollLeft / track.clientWidth), false),
      { passive: true }
    );

    const setButton = (variant) => {
      if (!button) return;
      if (!variant) {
        button.disabled = true;
        buttonLabel.textContent = strings.strUnavailable;
      } else {
        button.disabled = !variant.available;
        buttonLabel.textContent = variant.available ? strings.strAdd : strings.strSoldOut;
      }
    };

    const updatePrices = (variant) => {
      section.querySelectorAll("[data-price]").forEach((el) => (el.textContent = variant.price));
      const onSale = variant.compare_cents > variant.price_cents;
      const percent = onSale ? Math.round(((variant.compare_cents - variant.price_cents) * 100) / variant.compare_cents) : 0;
      section.querySelectorAll("[data-compare]").forEach((el) => {
        el.hidden = !onSale;
        el.textContent = variant.compare;
      });
      section.querySelectorAll("[data-save]").forEach((el) => {
        el.hidden = !onSale;
        el.textContent = strings.strSave.replace("[percent]", percent);
      });
      section.querySelectorAll("[data-bundle-discount]").forEach((option) => {
        const qty = Number(option.dataset.bundleQty);
        const paid = Number(option.dataset.bundlePaid || 0);
        const unit =
          paid > 0 && paid < qty
            ? Math.floor((variant.price_cents * paid) / qty)
            : Math.round((variant.price_cents * (100 - Number(option.dataset.bundleDiscount))) / 100);
        option.querySelector("[data-bundle-unit]").textContent = formatMoney(unit, strings.moneyFormat);
      });
      if (lowStock) {
        const low = variant.stock != null && variant.stock > 0 && variant.stock <= Number(lowStock.dataset.threshold);
        lowStock.hidden = variant.available && !low;
        if (!variant.available) lowStock.textContent = strings.strSoldOut;
        else if (low) lowStock.textContent = strings.strStock.replace("[count]", variant.stock);
      }
    };

    // Een optie is een rij knoppen (radio's) of een keuzelijst (select).
    const optionValue = (fs) => {
      const select = fs.querySelector("[data-option-select]");
      if (select) return select.value || null;
      return fs.querySelector("input:checked")?.value ?? null;
    };
    const selectedValues = () => fieldsets.map(optionValue);

    // Maten als "EU 35" … "EU 48" altijd op volgorde, ook als een maat later is toegevoegd.
    const euSize = (text) => {
      const match = /^EU\s*(\d+(?:[.,]\d+)?)$/i.exec(text.trim());
      return match ? parseFloat(match[1].replace(",", ".")) : null;
    };
    fieldsets.forEach((fs) => {
      const labels = [...fs.querySelectorAll("label")].filter((label) => label.querySelector('input[type="radio"]'));
      if (labels.length > 1 && labels.every((label) => euSize(label.querySelector("input").value) !== null)) {
        const parent = labels[0].parentElement;
        labels.sort((a, b) => euSize(a.querySelector("input").value) - euSize(b.querySelector("input").value)).forEach((label) => parent.appendChild(label));
      }
      const select = fs.querySelector("[data-option-select]");
      const options = select ? [...select.querySelectorAll("option")].filter((option) => option.value) : [];
      if (options.length > 1 && options.every((option) => euSize(option.value) !== null)) {
        options.sort((a, b) => euSize(a.value) - euSize(b.value)).forEach((option) => select.appendChild(option));
      }
    });

    // Uitverkocht: een kleur of maat zonder koopbare variant (bij de andere gekozen opties) wordt doorgestreept.
    const markSoldOut = () => {
      const values = selectedValues();
      fieldsets.forEach((fs, i) => {
        const buyable = (value) =>
          variants.some(
            (v) => v.available && v.options[i] === value && v.options.every((other, j) => j === i || values[j] === null || other === values[j])
          );
        fs.querySelectorAll('input[type="radio"]').forEach((input) => {
          const soldOut = !buyable(input.value);
          const label = input.closest("label");
          label?.classList.toggle("is-sold-out", soldOut);
          if (label) label.title = soldOut ? `${input.value} – ${strings.strSoldOut}` : input.value;
        });
        fs.querySelectorAll("[data-option-select] option[value]:not([value=''])").forEach((option) => {
          const soldOut = !buyable(option.value);
          option.textContent = soldOut ? `${option.value} – ${strings.strSoldOut}` : option.value;
        });
      });
    };
    markSoldOut();

    function onOptionChange() {
      markSoldOut();
      const values = selectedValues();
      fieldsets.forEach((fs, i) => {
        const label = fs.querySelector("[data-selected-label]");
        if (label) label.textContent = values[i] ?? "";
      });
      if (msg) msg.textContent = "";
      // Kleur gekozen maar maat nog niet: toon alvast de foto van die kleur.
      const partial = variants.find((v) => v.options.every((value, i) => values[i] === null || value === values[i]));
      if (partial) showSlide(partial.image_index);
      if (colorIndex > -1 && values[colorIndex] !== null) showColorMedia(values[colorIndex]);
      if (values.includes(null)) return;

      currentVariant = variants.find((v) => v.options.every((value, i) => value === values[i]));
      setButton(currentVariant);
      if (!currentVariant) return;

      idInput.value = currentVariant.id;
      updatePrices(currentVariant);
      const sticky = section.querySelector("[data-sticky-select]");
      if (sticky) sticky.value = currentVariant.id;
      const url = new URL(window.location.href);
      url.searchParams.set("variant", currentVariant.id);
      window.history.replaceState(null, "", url);
    }

    fieldsets.forEach((fs) => fs.addEventListener("change", onOptionChange));

    // Aantal en bundels: beide zetten hetzelfde aantal-veld.
    const setQuantity = (qty) => qtyInputs.forEach((input) => (input.value = Math.max(1, qty)));
    form.querySelectorAll("[data-qty-change]").forEach((step) =>
      step.addEventListener("click", () => setQuantity(Number(qtyInputs[0].value) + Number(step.dataset.qtyChange)))
    );
    const bundleOptions = [...form.querySelectorAll("[data-bundle-qty]")];
    bundleOptions.forEach((option) =>
      option.addEventListener("click", () => {
        const active = option.getAttribute("aria-pressed") !== "true";
        bundleOptions.forEach((o) => o.setAttribute("aria-pressed", String(o === option && active)));
        setQuantity(active ? Number(option.dataset.bundleQty) : 1);
      })
    );

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const missing = fieldsets.find((fs) => optionValue(fs) === null);
      if (missing) {
        msg.className = "form-msg error";
        msg.textContent = strings.strChoose.replace("[option]", missing.dataset.optionName.toLowerCase());
        missing.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      // Shopify's cart accepteert een uitverkochte variant soms toch; hier al tegenhouden.
      if (!currentVariant || !currentVariant.available) {
        msg.className = "form-msg error";
        msg.textContent = currentVariant ? strings.strSoldOut : strings.strUnavailable;
        return;
      }

      button.disabled = true;
      try {
        // Het bijgewerkte winkelwagen-paneel komt in hetzelfde antwoord mee.
        const body = new FormData(form);
        body.append("sections", "cart-drawer");
        const response = await fetch(`${strings.cartAddUrl}.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body,
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || strings.strError);

        const cart = await (await fetch(`${strings.cartUrl}.js`)).json();
        setCartCount(cart.item_count);
        msg.className = "form-msg success";
        msg.innerHTML = `${strings.strAdded} <a href="${strings.cartUrl}">${strings.strViewCart}</a>`;
        openCartDrawer(data.sections?.["cart-drawer"]);
      } catch (error) {
        msg.className = "form-msg error";
        msg.textContent = error.message || strings.strError;
      } finally {
        setButton(currentVariant);
      }
    });

    // Maattabel van deze schoen in een zijpaneel.
    const drawer = section.querySelector("[data-size-drawer]");
    form.querySelectorAll("[data-size-drawer-open]").forEach((link) =>
      link.addEventListener("click", (event) => {
        if (!drawer || typeof drawer.showModal !== "function") return;
        event.preventDefault();
        drawer.showModal();
      })
    );
    drawer?.querySelector("[data-size-drawer-close]").addEventListener("click", () => drawer.close());
    drawer?.addEventListener("click", (event) => event.target === drawer && drawer.close());

    // Plakbalk: verschijnt zodra de knop "In winkelwagen" uit beeld is.
    const sticky = section.querySelector("[data-sticky-buy]");
    if (sticky && button && "IntersectionObserver" in window) {
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }).observe(button);
      const select = sticky.querySelector("[data-sticky-select]");
      select?.addEventListener("change", () => {
        const variant = variants.find((v) => String(v.id) === select.value);
        if (!variant) return;
        fieldsets.forEach((fs, i) => {
          const select = fs.querySelector("[data-option-select]");
          if (select) select.value = variant.options[i];
          const input = [...fs.querySelectorAll("input")].find((el) => el.value === variant.options[i]);
          if (input) input.checked = true;
        });
        onOptionChange();
      });
      sticky.querySelector("[data-sticky-add]").addEventListener("click", () => form.requestSubmit());
    }
  });
}

// Winkelwagen: + en − passen het aantal aan en werken de winkelwagen direct bij.
function initCart(root) {
  root.querySelectorAll("[data-cart-form]").forEach((form) => {
    const updateButton = form.querySelector("[data-cart-update]");
    form.addEventListener("click", (event) => {
      const step = event.target.closest("[data-qty-step]");
      if (!step) return;
      const input = step.parentElement.querySelector("input");
      input.value = Math.max(0, Number(input.value) + Number(step.dataset.qtyStep));
      form.requestSubmit(updateButton);
    });
    form.addEventListener("change", (event) => {
      if (event.target.matches('input[name="updates[]"]')) form.requestSubmit(updateButton);
    });
  });
}

function setCartCount(count) {
  document.querySelectorAll("[data-cart-count]").forEach((el) => {
    el.textContent = count;
    bump(el);
  });
}

// Winkelwagen-paneel (sections/cart-drawer): schuift open na "In winkelwagen".
// Na + en − of verwijderen stuurt Shopify de sectie opnieuw mee en vervangen we de inhoud.
function updateCartDrawer(html) {
  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer || !html) return drawer;
  const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-drawer-content]");
  if (fresh) {
    drawer.querySelector("[data-cart-drawer-content]").replaceWith(fresh);
    if (drawer.open) fresh.focus({ preventScroll: true }); // focus blijft in het paneel
  }
  return drawer;
}

function openCartDrawer(html) {
  const drawer = updateCartDrawer(html);
  if (!drawer || typeof drawer.showModal !== "function" || drawer.open) return;
  drawer.showModal();
}

function initCartDrawer(root) {
  root.querySelectorAll("[data-cart-drawer]").forEach((drawer) => {
    drawer.addEventListener("click", async (event) => {
      if (event.target === drawer || event.target.closest("[data-cart-drawer-close]")) {
        drawer.close();
        return;
      }
      // Trustpilot-reviews: pijltjes schuiven één review verder.
      const step = event.target.closest("[data-tp-step]");
      if (step) {
        const track = drawer.querySelector("[data-tp-track]");
        track?.scrollBy({ left: Number(step.dataset.tpStep) * track.clientWidth, behavior: "smooth" });
        return;
      }
      // + en −, verwijderen, of "Add" bij een product uit "The perfect combination".
      const change = event.target.closest("[data-cart-change]");
      const add = event.target.closest("[data-upsell-add]");
      if (!change && !add) return;
      drawer.classList.add("is-busy");
      try {
        const payload = change
          ? { id: change.dataset.key, quantity: Number(change.dataset.cartChange) }
          : { items: [{ id: Number(add.closest("[data-upsell]").querySelector("[data-upsell-variant]").value), quantity: 1 }] };
        const url = change ? drawer.dataset.cartChangeUrl : drawer.dataset.cartAddUrl;
        const response = await fetch(`${url}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ ...payload, sections: "cart-drawer" }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description);
        updateCartDrawer(data.sections?.["cart-drawer"]);
        // cart/change geeft de hele winkelwagen terug, cart/add alleen het toegevoegde product.
        const count = change ? data.item_count : (await (await fetch(`${drawer.dataset.cartUrl}.js`)).json()).item_count;
        setCartCount(count);
      } catch {
        window.location.href = drawer.dataset.cartUrl; // valt terug op de winkelwagenpagina
      } finally {
        drawer.classList.remove("is-busy");
      }
    });
  });
}

// Footer: op mobiel ingeklapt en uitklapbaar, op grotere schermen altijd open.
function initFooter(root) {
  const columns = [...root.querySelectorAll("[data-footer-col]")];
  if (!columns.length) return;
  const mobile = window.matchMedia("(max-width: 600px)");
  const sync = () => columns.forEach((col) => (col.open = !mobile.matches));
  columns.forEach((col) =>
    col.querySelector("summary").addEventListener("click", (event) => {
      if (!mobile.matches) event.preventDefault();
    })
  );
  mobile.addEventListener("change", sync);
  sync();
}

// Productkaarten op touchscreens: één korte zweefbeweging bij tikken, daarna naar de productpagina.
function initCardTap(root) {
  const touch = window.matchMedia("(hover: none)");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  root.querySelectorAll(".floaty-trigger").forEach((card) => {
    card.addEventListener("click", (event) => {
      if (!touch.matches || reducedMotion.matches || !card.querySelector(".floaty-hover")) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || card.classList.contains("is-tapped")) return;
      event.preventDefault();
      card.classList.add("is-tapped");
      setTimeout(() => (window.location.href = card.href), 450);
    });
  });
}

// Terug naar de pagina (bfcache): kaarten weer in rust.
window.addEventListener("pageshow", () => {
  document.querySelectorAll(".is-tapped").forEach((card) => card.classList.remove("is-tapped"));
});

function init(root) {
  initMenu(root);
  initAnnouncement(root);
  initScrollDots(root);
  initFooter(root);
  initCardTap(root);
  initFilters(root);
  initShoeFinder(root);
  initCountdowns(root);
  initShipDates(root);
  initProduct(root);
  initCart(root);
  initCartDrawer(root);
}

init(document);
document.addEventListener("shopify:section:load", (event) => init(event.target));
